import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { listingsApi as r } from "@maat/api-main";
//#region src/properties/useDeleteListingMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteListing(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.property() }), i.invalidateQueries({ queryKey: e.unit() }), i.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { i as useDeleteListingMutation };
